import { Button } from "@/components/ui/button";
import { useOpenEsign } from "@/hooks/useOpenEsign";

interface UnitRentButtonProps {
    tier?: string;
    handleRentalClick: () => void;
    label?: string;
}

export const RentButton = ({
    tier = "tierA",
    handleRentalClick,
    label = "Rent",
}: UnitRentButtonProps) => {
    useOpenEsign();

    const bgClass =
        tier === "tierB" ? "tw:bg-(--secondary)" : "tw:bg-(--primary)";

    return (
        <Button
            variant="default"
            data-testid="rentButton"
            onClick={handleRentalClick}
            className={`${bgClass} hover:${bgClass} tw:hover:brightness-75 rent-btn`}
            aria-label={label}
            type="button"
        >
            {label}
        </Button>
    );
};

RentButton.displayName = "RentButton";
